import "bootstrap/dist/css/bootstrap-grid.css"

import React from "react"

import AppleStore from "../icons/Apple"
import GooglePlay from "../icons/Google_Play"
import Logo from "../icons/Logo"
import Styles from "./styles.module.scss"
import BCorpLog from "../../../images/b-corp.png"

const Footer = () => {
  const {
    wrapper,
    copyWrapper,
    footer,
    columnWrapper,
    columnHeader,
    logoWrapper,
    appWrapper,
    noMarginBottom,
    bCorp
  } = Styles
  return (
    <footer className={footer}>
      <div className={`container h6 ${noMarginBottom}`}>
        <div className={`row ${wrapper}`}>
          <div className={`col-sm-12 col-md-4 ${copyWrapper} small`}>
            <picture>
              <div className={`${logoWrapper}`}>
                <Logo />
              </div>
            </picture>
            <p>
              Coursera is the global online learning platform that offers
              anyone, anywhere access to online courses and degrees from
              world-class universities and companies.
            </p>
            <p className="small">
              &copy;
              {` ${new Date().getFullYear()} `}
              Coursera Inc. All rights reserved.
            </p>
            <picture>
              <div className={`${appWrapper}`}>
                <AppleStore />
              </div>
            </picture>
            <picture>
              <div className={`${appWrapper}`}>
                <GooglePlay />
              </div>
            </picture>
            <div className={`${appWrapper}`}><img src={BCorpLog} alt="Certified B Corporation" className={bCorp} height="120px" /></div>
          </div>

          <div className={`col-sm-12 col-md-4 ${copyWrapper}`}>
            <div className={`col-sm-6 col-md-6 ${columnWrapper}`}>
              <ul>
                <li className={`${columnHeader} initialism`}>Coursera</li>
                <li className="small">
                  <a href="https://about.coursera.org/">About</a>
                </li>
                <li className="small">
                  <a href="https://about.coursera.org/how-coursera-works/">
                    What We Offer
                  </a>
                </li>
                <li className="small">
                  <a href="https://blog.coursera.org/leadership/">Leadership</a>
                </li>
                <li className="small">
                  <a href="https://about.coursera.org/careers">Careers</a>
                </li>
                <li className="small">
                  <a href="https://www.coursera.org/browse">Catalog</a>
                </li>
                <li className="small">
                  <a href="https://www.coursera.org/degrees">Degrees</a>
                </li>
                <li className="small">
                  <a href="https://www.coursera.org/professional-certificate">
                    Professional Certificates
                  </a>
                </li>
                <li className="small">
                  <a href="https://www.coursera.org/mastertrack">
                    MasterTrack&trade; Certificates
                  </a>
                </li>
                <li className="small">
                  <a href="https://www.coursera.org/business">For Enterprise</a>
                </li>
                <li className="small">
                  <a href="https://www.coursera.org/government">
                    For Government
                  </a>
                </li>
                <li className="small">
                  <a href="https://www.coursera.org/campus">For Campus</a>
                </li>
                <li className="small">
                  <a href="https://partnerships.coursera.org/?utm_medium=coursera&utm_source=partnerships&utm_campaign=website&utm_content=marketing-footer-become-a-partner">Become a Partner</a>
                </li>
              </ul>
            </div>
            <div className={`col-sm-6 col-md-6 ${columnWrapper}`}>
              <ul>
                <li className={`${columnHeader} initialism`}>Community</li>
                <li className="small">
                  <a href="https://coursera.community/">Learners</a>
                </li>
                <li className="small">
                  <a href="https://www.coursera.org/about/partners">Partners</a>
                </li>
                <li className="small">
                  <a href="https://coursera.community/gtc-news-announcements-17/join-the-coursera-global-translator-community-45">
                    Translators
                  </a>
                </li>
                <li className="small">
                  <a href="https://building.coursera.org/developer-program/">
                    Developers
                  </a>
                </li>
                <li className="small">
                  <a href="https://coursera.community/beta-tester-news-announcements-20/join-the-coursera-beta-tester-community-47">
                    Beta Testers
                  </a>
                </li>
                <li className="small">
                  <a href="https://www.coursera.org/teaching-center/">
                    Teaching Center
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className={`col-sm-12 col-md-4 ${copyWrapper}`}>
            <div className={`col-sm-6 col-md-6 ${columnWrapper}`}>
              <ul>
                <li className={`${columnHeader} initialism`}>Connect</li>
                <li className="small">
                  <a
                    href="https://blog.coursera.org/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Blog
                  </a>
                </li>
                <li className="small">
                  <a
                    href="https://www.facebook.com/Coursera"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Facebook
                  </a>
                </li>
                <li className="small">
                  <a
                    href="https://www.linkedin.com/company/coursera/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    LinkedIn
                  </a>
                </li>
                <li className="small">
                  <a
                    href="https://twitter.com/coursera"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Twitter
                  </a>
                </li>
                <li className="small">
                  <a
                    href="https://www.instagram.com/coursera/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Instagram
                  </a>
                </li>
                <li className="small">
                  <a
                    href="https://building.coursera.org/"
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    Tech Blog
                  </a>
                </li>
              </ul>
            </div>
            <div className={`col-sm-6 col-md-6 ${columnWrapper}`}>
              <ul>
                <li className={`${columnHeader} initialism`}>More</li>
                <li className="small">
                  <a href="https://www.coursera.org/about/terms">Terms</a>
                </li>
                <li className="small">
                  <a href="https://www.coursera.org/about/privacy">Privacy</a>
                </li>
                <li className="small">
                  <a href="https://learner.coursera.help/hc/en-us">Help</a>
                </li>
                <li className="small">
                  <a href="https://learner.coursera.help/hc/en-us/articles/208280056-Accommodations-for-learners-with-disabilities">
                    Accessibility
                  </a>
                </li>
                <li className="small">
                  <a href="https://about.coursera.org/press">Press</a>
                </li>
                <li className="small">
                  <a href="https://www.coursera.org/about/contact">Contact</a>
                </li>
                <li className="small">
                  <a href="https://www.coursera.org/articles">Articles</a>
                </li>
                <li className="small">
                  <a href="https://www.coursera.org/directory">Directory</a>
                </li>
                <li className="small">
                  <a href="https://about.coursera.org/affiliates">Affiliates</a>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
